import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";
import { newConferenceZoneBookingActivityBased } from "../../../utils/axios-requests";
import {
  buildConferenceVisitorRegistrationDtos,
  conferenceRoomLocationFromInputs
} from "../functions/team-visitor-invitation.functions";
import { BookingStrategyContext } from "./bookingStrategies";
import { buildUsers } from "./buildUsers.function";

export const conferenceZoneActivityStrategy = (ctx: BookingStrategyContext) => {
  const users = buildUsers(ctx);
  const conferenceZoneVisitorRegistrations = buildConferenceVisitorRegistrationDtos(
    ctx.inputs.visitorRegistrations,
    conferenceRoomLocationFromInputs(ctx.inputs)
  );

  ctx.handlePromise(
    newConferenceZoneBookingActivityBased({
      users,
      weekdays: Object.values(ctx.inputs.weekdays).some(Boolean) ? ctx.inputs.weekdays : undefined,
      bookingType: ctx.inputs.bookingType as BookingType,
      locationInventoryId: ctx.inputs.selectedLocation,
      subject: ctx.inputs.subject,
      description: ctx.inputs.description,
      conferenceZoneBookingGuests: ctx.inputs.zoneAccess || [],
      conferenceZoneVisitorRegistrations,
      onlineMeetingProvider: ctx.inputs.onlineMeetingProvider || null,
      bookingServicesDto: ctx.handleToBookingServiceDto(
        users[0].bookingInventoryId,
        ctx.inputs.conferenceService
      ),
      ...ctx.standardBookingInfo,
      ...ctx.standardBookingTimes
    }),
    ctx.onSuccess,
    ctx.onError
  );
};
